import React from 'react';
import './App.css';
import Router from './routes/Router';
import AlertModal from './layouts/alert/AlertModal';
import OtpModal from './layouts/modal/OtpModal';
import ConfirmModal from './layouts/modal/ConfirmModal';
import ChangePasswordModal from './layouts/modal/ChangePasswordModal';
import { CssBaseline, ThemeProvider } from '@mui/material';
import { useSelector } from 'react-redux';
import themes from './layouts/theme-main/Theme';
import NavigationScroll from './routes/NavigationScroll';
import { useEffect } from 'react';
import { genAppToken } from './services/GenAppToken';
import Storage from './services/Storage';

function App() {
  const customization = useSelector(state => state.customization);
  const theme = themes(customization);

  useEffect(() => {
    const appToken = genAppToken();
    appToken.then(result => {
      Storage.updateLocalAppToken(result.token)
    }).catch(err => {
      console.log(err);
    })
  }, [])

  return (
    <React.Fragment>
      <div className="App">
        <CssBaseline />
        <ThemeProvider theme={theme}>
          <AlertModal></AlertModal>
          <OtpModal></OtpModal>
          <ConfirmModal></ConfirmModal>
          <NavigationScroll>
            <Router></Router>
          </NavigationScroll>
          <ChangePasswordModal></ChangePasswordModal>
        </ThemeProvider>
      </div>
    </React.Fragment >
  );
}

export default App;
